import type { Field } from 'components/user/DummyHelios/Uploader/UploadFile';
import type { FileResponse } from './documentStorage';

export enum BiometryAuthType {
  Fingerprint = 'fingerprint',
  FacialRecognition = 'facialRecognition',
  Iris = 'iris',
}

export enum ReactNativeMessageType {
  SetEditMode = 'setEditMode',
  ChangeLanguage = 'changeLanguage',
  DownloadNotificationFile = 'downloadNotificationFile',
  NotificationCount = 'notificationCount',
  DownloadFileBase64 = 'downloadFileBase64',
  DownloadFile = 'downloadFile',
  OpenFile = 'openFile',
  MappingGoogle = 'mappingGoogle',
  MappingMicrosoft = 'mappingMicrosoft',
  OpenGoogleDriveFile = 'openGoogleDriveFile',
  MicrosoftRefreshToken = 'microsoftRefreshToken',
  GoogleRefreshToken = 'googleRefreshToken',
  Logout = 'logout',
  SetFastSignInMethod = 'setFastSignInMethod',
  ChangeFastSignInPin = 'changeFastSignInPin',
  RedirectToUserProfile = 'redirectToUserProfile',
  RequestFastSignInInfo = 'requestFastSignInInfo',
  SendFastSignInInfo = 'sendFastSignInInfo',
}

export enum FastSignInMethod {
  Pin = 'pin',
  Biometry = 'biometry',
  None = 'none',
}

export type FastSignInInfoPayload = {
  selectedMethod: FastSignInMethod | null;
  isBiometryAvailable: boolean;
  biometryAuthType: BiometryAuthType | null;
};

export type ReactNativeMessagePayloads = {
  [ReactNativeMessageType.SetEditMode]: {
    isEditMode: boolean;
  };

  [ReactNativeMessageType.ChangeLanguage]: {
    value: string;
  };

  [ReactNativeMessageType.DownloadNotificationFile]: { url: string; token: string };

  [ReactNativeMessageType.NotificationCount]: { count: number };

  [ReactNativeMessageType.DownloadFileBase64]: { fileName: string; fileType: string; file: string | undefined };

  [ReactNativeMessageType.DownloadFile]: { file: Field | FileResponse; token: string };

  [ReactNativeMessageType.OpenFile]: {
    file: Field | FileResponse;
    token: string;
  };

  [ReactNativeMessageType.MappingGoogle]: {
    datasourceId: string;
    token: string;
  };

  [ReactNativeMessageType.MappingMicrosoft]: {
    datasourceId: string;
    token: string;
  };

  [ReactNativeMessageType.OpenGoogleDriveFile]: {
    file: FileResponse;
  };

  [ReactNativeMessageType.MicrosoftRefreshToken]: {
    refreshToken: string;
  };

  [ReactNativeMessageType.GoogleRefreshToken]: {
    refreshToken: string;
  };

  [ReactNativeMessageType.Logout]: {
    jwtToken: string | null;
  };

  [ReactNativeMessageType.SetFastSignInMethod]: {
    method: FastSignInMethod;
  };

  [ReactNativeMessageType.ChangeFastSignInPin]: Record<string, never>;

  [ReactNativeMessageType.RedirectToUserProfile]: Record<string, never>;

  [ReactNativeMessageType.RequestFastSignInInfo]: Record<string, never>;

  [ReactNativeMessageType.SendFastSignInInfo]: FastSignInInfoPayload;
};
